"use client";

import { useEffect, useRef } from "react";
import { useToast } from "@/app/_module/components/ui/use-toast";
import { useDialBlocker } from "@/app/_module/hooks/useDialBlocker";

// Heads-up toast the first time a dial blocker is detected in a session
// (expired number, deactivated number, failed payment, trial over, subscription
// ended). Fires once per cause per session so it says it, then gets out of
// the way — the page banner and the dialer banner carry it after that.
const KEY = "ic-dial-blocker-toasted";

export function DialBlockerToast() {
  const { blocked, blocker } = useDialBlocker();
  const { toast } = useToast();
  const shown = useRef<string | null>(null);

  useEffect(() => {
    if (!blocked || !blocker) return;
    // A plan without a phone (Lite) isn't a problem to fix: no dialer, no toast.
    if (blocker.kind === "plan_no_telephony") return;
    let already: string | null = null;
    try { already = sessionStorage.getItem(KEY); } catch { /* private mode */ }
    if (already === blocker.kind || shown.current === blocker.kind) return;
    shown.current = blocker.kind;
    try { sessionStorage.setItem(KEY, blocker.kind); } catch { /* ignore */ }
    toast({
      title: blocker.title,
      description: `${blocker.body} Tap "${blocker.cta}" in the banner above, or open the dialer.`,
      variant: "destructive",
      duration: 10000,
    });
  }, [blocked, blocker, toast]);

  return null;
}
